import { DiscountType, GlobalPromotionMode } from '@storefronts/common-types'
import { HashedPromotion } from '@/components/promotions/types'
import { fallbackModeFromGlobal } from './defaultPromotion'
import { DefaultPromotion, DefaultSpecificPromotion } from './types'

export function hashedFromSpecific(
    promotion: DefaultSpecificPromotion,
): HashedPromotion {
    return {
        hash: promotion.id,
        name: promotion.name,
        bannerText: promotion.bannerText ?? '',
        discountCode: promotion.discountCode ?? '',
        discountType: promotion.discountType,
        discountValue: promotion.discountValue,
        combinesWithOrderDiscounts: false,
        combinesWithProductDiscounts: false,
        combinesWithShippingDiscounts: false,
    }
}

export function specificFromHashed(
    promotion: HashedPromotion,
): DefaultSpecificPromotion {
    return {
        id: promotion.hash,
        name: promotion.name,
        discountCode: promotion.discountCode ?? null,
        discountType: DiscountType[promotion.discountType],
        discountValue: promotion.discountValue ?? 0,
        bannerText: promotion.bannerText ?? null,
    }
}

export function defaultFromSettings(
    mode: GlobalPromotionMode,
    promotion: HashedPromotion | null,
): DefaultPromotion {
    const fallback = fallbackModeFromGlobal(mode)
    if (fallback === 'DISABLED') return { kind: 'DISABLED' }
    if (fallback === 'AUTO_SYNC') return { kind: 'AUTO_SYNC' }
    if (promotion) {
        return { kind: 'SPECIFIC', promotion: specificFromHashed(promotion) }
    }
    return { kind: 'UNSET' }
}
